module.exports = __webpack_public_path__ + "static/media/accordion.37abc1b2.jpg";